/**
 * Fensterhöhe festschreiben: --pa-vh = 1 % der sichtbaren Höhe beim Laden, in px.
 *
 * Mobile Browser (vor allem iOS) ändern vh/svh/dvh, sobald die Adress- bzw. Werkzeugleiste beim Scrollen ein- oder
 * ausfährt. Alles, was daran hängt (Hero-Höhe, Abstände), springt dann. Mit dem festen Wert bleibt das Layout ruhig.
 * Aktualisiert wird nur, wenn sich die BREITE ändert (Drehen des Geräts, Fenster am Desktop) oder – auf Geräten mit
 * Maus – bei jeder Größenänderung. Reine Höhenänderungen auf Touch-Geräten sind die Browserleiste und werden ignoriert.
 */
export function init() {
	const root = document.documentElement;
	const touch = window.matchMedia('(hover: none) and (pointer: coarse)');
	let width = window.innerWidth;

	const set = () => root.style.setProperty('--pa-vh', `${(window.innerHeight / 100).toFixed(3)}px`);
	set();

	window.addEventListener('resize', () => {
		if (touch.matches && window.innerWidth === width) return;
		width = window.innerWidth;
		set();
	}, { passive: true });
	window.addEventListener('orientationchange', () => window.setTimeout(() => { width = window.innerWidth; set(); }, 250));
}
